import { defineStore, _ActionsTree, _GettersTree } from "pinia";
import _ from "lodash";
import UserApi from "~/serverapi/User";
import usePub from "~/store/Public";
export interface StoreState {
	LoginInfo: {
		status: boolean;
		api_token: string;
		code: string;
	};
	Point: {
		company: number;
		person: number;
		total: number;
	};
	Info: {
		method: string | null;
		name: string | null;
		showname: string | null;
		agencyName: string | null;
		email: string | null;
		image: string | null;
		uid: string | null;
		agency: string | null;
		wUid: string | null;
		lastPayClose: string;
		main?: number | string | null;
		sort: {
			person: {
				edit: number | null;
				match: number | null;
				signup: number | null;
			};
			agency: {
				edit: string | null;
				show: string | null;
				sale: string | null;
				pay: string | null;
				collection: string | null;
				expend: string | null;
				expenses: string | null;
				back: number | null;
				manage: number | null;
				noFunc: Array<string>;
			};
			forgot: {
				ischeck: number | null;
				date: string | null;
			};
			verify: {
				open: {
					ischeck: number | null;
					date: string | null;
				};
			};
		};
		gender: string | null;
		phone: string | null;
		isVerification: number | null;
		verifyDate: string | null;
		cktime: string | null;
		url: {
			index: string | null;
			manage: string | null;
			member: string | null;
		};
		allowBig: string;
		allowSmall: string;
	};
	highestAuth: Array<string>;
}

// 建議以initState先聲明在useStore之前，這樣比較好用，尤其是reset的情況特別好用
const initState: StoreState = {
	LoginInfo: {
		status: false,
		api_token: "",
		code: "",
	},
	Point: {
		company: 0,
		person: 0,
		total: 0,
	},
	Info: {
		method: "",
		name: "admin",
		showname: "Dagee-admin",
		agencyName: "Dagee",
		email: "",
		image: "",
		uid: "",
		agency: "",
		wUid: "",
		lastPayClose: "",
		main: 0,
		sort: {
			person: {
				edit: 0,
				match: 0,
				signup: 0,
			},
			agency: {
				edit: "",
				show: "",
				sale: "",
				pay: "",
				collection: "",
				expend: "",
				expenses: "",
				back: 1,
				manage: 0,
				noFunc: [],
			},
			forgot: {
				ischeck: null,
				date: null,
			},
			verify: {
				open: {
					ischeck: 0,
					date: "",
				},
			},
		},
		gender: "",
		phone: "",
		isVerification: 0,
		verifyDate: "",
		cktime: "2023-07-03 05:10",
		url: { index: "", manage: "", member: "" },
		allowBig: "",
		allowSmall: "",
	},

	highestAuth: ["AG23083000010M1"],
};
const getters: _GettersTree<StoreState> = {
	getAuth(state) {
		return _.indexOf(state.highestAuth, state.Info.agency) > -1;
	},
	getSort(state) {
		return state.Info.sort;
	},
	async encodeApi(state) {
		return usePub().htmlspecialchars(state.LoginInfo.api_token);
	},
	// getTripleCount: (state) => state.count * 3,
};
const useStore = defineStore("UserInfo", {
	state: () => {
		return _.cloneDeep(initState);
	},
	actions: {
		async checkUser() {
			try {
				const userinfo = await UserApi.checkUser();
				this.LoginInfo.status = userinfo.result.login;
				if (this.LoginInfo.status) {
					this.Info.cktime = userinfo.result.cktime;

					this.Info.url.index = userinfo.result.index;
					this.Info.url.manage = userinfo.result.manage;
					this.Info.url.member = userinfo.result.member;

					this.LoginInfo.code = userinfo.result.code;
				} else {
					this.LoginInfo = _.cloneDeep(initState.LoginInfo);
					this.Info = _.cloneDeep(initState.Info);
				}
				return this.LoginInfo.status;
			} catch (e) {
				this.LoginInfo = _.cloneDeep(initState.LoginInfo);
				this.Info = _.cloneDeep(initState.Info);

				return false;
			}
		},
		async getBaseUser() {
			const userinfo = await UserApi.getBaseUser();

			if (userinfo.status) {
				const CuserInfo = userinfo.result;
				this.LoginInfo.api_token = localStorage.getItem("auth")?.toString() || "";
				this.LoginInfo.status = CuserInfo.status;
				delete CuserInfo.status;
				this.Info = CuserInfo;
				if (!this.Info.sort.verify.open.ischeck) {
					useRouter().push({
						name: "verification",
					});
				}
			} else {
				this.LoginInfo = _.cloneDeep(initState.LoginInfo);
				this.Info = _.cloneDeep(initState.Info);
			}
			return this.Info.sort.verify.open.ischeck;
		},
		async Signup(data: any) {
			const signinfo = await UserApi.Signup(data);
			this.LoginInfo.status = signinfo.status;
			if (signinfo.status) {
				this.LoginInfo.api_token = signinfo.result.api_token;
				localStorage.setItem("auth", signinfo.result.api_token);
				this.getBaseUser();
			}
			return signinfo;
		},
		async CheckCompany(taxId: any) {
			const Checkinfo = await UserApi.CheckCompany(taxId);
			this.LoginInfo.status = Checkinfo.status;
			if (!Checkinfo.status) {
				usePub().setAlertList({
					title: Checkinfo.result.message,
					message: Checkinfo.result.message,
					color: Checkinfo.status ? "success" : "danger",
					textColor: "white",
				});
			}
			return Checkinfo;
		},
		async Login(Login: { account: string; password: string; verifyCode: string }) {
			const LoginInfo = await UserApi.Login(Login);
			usePub().setAlertList({
				title: LoginInfo.status ? "登入成功" : "登入失敗",
				message: LoginInfo.result.message,
				color: LoginInfo.status ? "success" : "danger",
				textColor: "white",
			});
			this.LoginInfo.status = LoginInfo.status;
			this.LoginInfo.api_token = "";
			localStorage.setItem("auth", "");
			let cknext = LoginInfo.status;
			if (LoginInfo.status) {
				this.LoginInfo.api_token = LoginInfo.result.api_token;
				localStorage.setItem("auth", LoginInfo.result.api_token);
				cknext = this.getBaseUser();
			}
			return {
				status: cknext,
			};
		},
		async Logout() {
			const LInfo = await UserApi.Logout();
			console.log(initState.LoginInfo);
			this.LoginInfo = _.cloneDeep(initState.LoginInfo);
			this.Info = _.cloneDeep(initState.Info);
			localStorage.setItem("auth", "");
			usePub().setAlertList({
				title: "登出",
				message: "已登出平台",
				textColor: "white",
			});
			return LInfo;
		},
		async getFuncLevel(funcName: string = "") {
			const level = await UserApi.getFuncLevel(funcName);
			return level.result.info;
		},
		async getVerification(method: string) {
			return UserApi.getVerification(method);
		},
		async sendVerification(method: string, $code: string) {
			return UserApi.sendVerification(method, $code);
		},
		async getCompanyPerson(acUid: string) {
			return UserApi.getCompanyPerson(acUid);
		},
		async getCompanyInfo() {
			return UserApi.getCompanyInfo();
		},
		async getCompanyAccount() {
			return UserApi.getCompanyAccount();
		},
		async SaveAccountInfo(type: string, formData: any) {
			return UserApi.SaveAccountInfo(type, formData);
		},
		async SaveCompanyInfo(formData: any) {
			return UserApi.SaveCompanyInfo(formData);
		},
		async ChangePasswordInfo(method: string, formData: any) {
			return UserApi.ChangePasswordInfo(method, formData);
		},
		async changeAccess(uid: string, formData: any) {
			return UserApi.changeAccess(uid, formData);
		},
		async deleteUser(uid: string) {
			return UserApi.deleteUser(uid);
		},
		async getBankAccount(where: any = {}) {
			return UserApi.getBankAccount(where);
		},
		async getBankAccountInfo(bankUid: string) {
			return UserApi.getBankAccountInfo(bankUid);
		},
		async settingService() {
			return UserApi.settingService();
		},
		async EditsettingService(formdata: any) {
			return UserApi.EditsettingService(formdata);
		},
		getBankList(request = {}) {
			return UserApi.getBankList(request);
		},
		addBank(formdata: any) {
			return UserApi.addBank(formdata);
		},
		EditBank(uid: string, formdata: any) {
			return UserApi.EditBank("edit", uid, formdata);
		},
		EditTapPay(formdata: any) {
			return UserApi.EditTapPay(formdata);
		},
		Edit91App(formdata: any) {
			return UserApi.Edit91App(formdata);
		},
		check91App(txntoken: string, payMethod: string | null = null) {
			return UserApi.check91App(txntoken, payMethod);
		},

		checkInCollection(method: string, Pmethod: string, uid: string) {
			return UserApi.checkInCollection(method, Pmethod, uid);
		},
		checkFundPay(payMethod: string | null = null) {
			return UserApi.checkFundPay(payMethod);
		},
		EditFundPay(formdata: any) {
			return UserApi.EditFundPay(formdata);
		},
		editCompanyStamp(formdata: any, uid: string = "add") {
			uid = uid || "add";
			return UserApi.editCompanyStamp(formdata, uid);
		},
		getCompanyStampList() {
			return UserApi.getCompanyStampList();
		},
		//平台上線這段要刪除
		getAgencyList() {
			return UserApi.getAgencyList();
		},
		getTraveler(search: any = {}, page: number, pagenumber: number, orderBy: { name: string; order: string }) {
			return UserApi.getTraveler(search, page, pagenumber, orderBy);
		},

		getVendor(search: any = {}, page: number, pagenumber: number, orderBy: { name: string; order: string }) {
			return UserApi.getVendor(search, page, pagenumber, orderBy);
		},
		getMember(search: any = {}, page: number, pagenumber: number, orderBy: { name: string; order: string }, addfunc: Array<string> = []) {
			return UserApi.getMember(search, page, pagenumber, orderBy, addfunc);
		},
		getVendorInfo(uid: string) {
			return UserApi.getVendorInfo(uid);
		},
		getMemberInfo(uid: string) {
			return UserApi.getMemberInfo(uid);
		},
		EditVendorInfo(uid: string, formdata: any) {
			return UserApi.EditVendorInfo(uid, formdata);
		},
		EditMemberInfo(uid: string, formdata: any) {
			return UserApi.EditMemberInfo(uid, formdata);
		},
		getMemberDashboard(uid: string) {
			return UserApi.getMemberDashboard(uid);
		},
		getMemberEditLog(uid: string, page: number, pagenumber: number | "all" = 20) {
			return UserApi.getMemberEditLog(uid, page, pagenumber);
		},
		getLevelGroupList(page: number, pagenumber: string | number, search: any = {}) {
			return UserApi.getLevelGroupList(page, pagenumber, search);
		},
		getLevelGroupInfo(uid: string) {
			return UserApi.getLevelGroupInfo(uid);
		},
		EditLevelGroup(uid: string = "", formdata: any) {
			return UserApi.EditLevelGroup(uid, formdata);
		},
		getDashBoard() {
			return UserApi.getDashBoard();
		},
	},
	getters,
});
export default useStore;
